import { useRef } from 'react';
import { isMoment } from 'moment';
import isEqualWith from 'lodash/isEqualWith';
import { useAppSelector } from '@web-common/state/createStore';
const customizer = (tV, sV) => {
    if (isMoment(tV) && isMoment(sV)) {
        return tV.isSame(sV);
    }
    return undefined;
};
function useConferenceSelector() {
    const ref = useRef();
    const conference = useAppSelector(state => state.mailReducer.currentMail.conference);
    if (conference) {
        const { moments: { startDate, endDate, startTime = startDate, endTime = endDate }, time: { allDay }, } = conference;
        const result = {
            startDate,
            endDate,
            startTime,
            endTime,
            allDay,
        };
        if (!ref.current || !isEqualWith(ref.current, result, customizer)) {
            ref.current = result;
        }
    }
    return ref.current;
}
export default useConferenceSelector;
